export default __webpack_public_path__ + "static/media/Workstation_Start.5897f6d5.jpg";